import { useTranslation } from 'react-i18next';

import { Iframe } from '~/components/Iframe';

export function AutomatedCampaignsPage() {
  const { t } = useTranslation('marketing');

  return (
    <div className="m-xs h-[calc(100vh-80px)]">
      <Iframe
        urlEnvKey="VITE_WMG_EMBED_MARKETING_AUTOMATED_CAMPAIGNS_DASHBOARD_URL"
        ariaLabel={t('automatedCampaigns.iframeLabel')}
      />
    </div>
  );
}

AutomatedCampaignsPage.displayName = 'AutomatedCampaignsPage';
